import React, { useState, useEffect } from "react";
import { doc, getDoc, updateDoc,setDoc } from "firebase/firestore";
import { MainDb } from "../fireMainStore";

const ThemeController = () => {
  const [theme, setTheme] = useState("");

  useEffect(() => {
    const loadTheme = async () => {
      const ref = doc(MainDb, "settings", "store");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setTheme(snap.data().theme || "");
      }
    };
    loadTheme();
  }, []);

const saveTheme = async () => {
  const ref = doc(MainDb, "settings", "store");

  await setDoc(
    ref,
    { theme },
    { merge: true } // ← creates if missing, updates if exists
  );

  alert("Theme updated");
};

  return (
    <div style={{ padding: 20 }}>
      <h2>Store Theme Controller</h2>

      <select
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
        style={{ padding: 10, marginRight: 10 }}
      >
        <option value="">None</option>
        <option value="iran">🇮🇷 Iran</option>
        <option value="christmas">🎄 Christmas</option>
        <option value="halloween">🎃 Halloween</option>
        <option value="valentine">❤️ Valentine</option>
      </select>

      <button onClick={saveTheme}>
        Save Theme
      </button>
    </div>
  );
};

export default ThemeController;